import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';

import { STATIC_ROOT } from '../../constants';

import { scrollToInvalid } from './utils';

import SvgComponent from '../SvgComponent';
import ButtonComponent from '../button/ButtonComponent';
import { LoadingComponent } from '../loading/LoadingComponent';

// TODO Check styles as there was strange cases
import { FormSubmitContainer } from './FormComponentStyle';

class FormComponent extends React.Component {
    onSubmitForm = data => this.props.onSubmit(data);

    renderLoading = () => {
        const { requestSubmit } = this.props;
        if (requestSubmit) {
            return <LoadingComponent />;
        }
    };

    renderSubmitButton = () => {
        const { i18n, requestSubmit, submitText, hideButton, buttonColor } = this.props;
        if (!requestSubmit && !hideButton) {
            return (
                <ButtonComponent
                    type="submit"
                    color={buttonColor ? buttonColor : 'main'}
                    text={submitText ? submitText : i18n.SUBMIT}
                />
            );
        }
    };

    renderPaymentLock = () => {
        const { paymentLockLabel } = this.props;
        return (
            <div className="lock-label">
                <SvgComponent src={`${STATIC_ROOT}/lockpad.svg`} width="14" height="14" />
                <span className="lockpad-label">{paymentLockLabel}</span>
            </div>
        );
    };

    // Inject i18n form object into Field input
    childrenWithProps = () =>
        React.Children.map(
            this.props.children,
            child =>
                child &&
                React.cloneElement(child, {
                    i18nFeatureForm: this.props.i18n,
                    formName: this.props.name
                })
        );

    render() {
        const {
            form,
            handleSubmit,
            className,
            classNameInputContainer,
            encType,
            paymentLockLabel
        } = this.props;

        return (
            <form
                id={form}
                className={className}
                onSubmit={handleSubmit(this.onSubmitForm)}
                encType={encType ? 'multipart/form-data' : ''}>
                <div className={classNameInputContainer}>{this.childrenWithProps()}</div>

                <FormSubmitContainer className={paymentLockLabel ? 'lock' : ''}>
                    {this.renderLoading()}
                    {this.renderSubmitButton()}
                    {paymentLockLabel && this.renderPaymentLock()}
                </FormSubmitContainer>
            </form>
        );
    }
}

FormComponent.propTypes = {
    className: PropTypes.string,
    classNameInputContainer: PropTypes.string,
    form: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
    onSubmit: PropTypes.func,
    encType: PropTypes.bool,
    requestSubmit: PropTypes.bool,
    errorSubmit: PropTypes.bool,
    submitText: PropTypes.string,
    hideButton: PropTypes.bool,
    buttonColor: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.feature.form
    };
};

/**
 * initialValues is used by redux form to initialize input value
 * initialValues must be a valid json object with key corresponding to input Field name attribute
 */
export default connect(mapStateToProps)(
    reduxForm({ onSubmitFail: errors => scrollToInvalid(errors) })(FormComponent)
);



// WEBPACK FOOTER //
// ./src/components/form/FormComponent.js